module.exports = __webpack_public_path__ + "static/img/ex_img3.239a1775.png";